import { ScrollViewResizeCenter } from "./ScrollViewResizeCenter.js";
import { ScrollViewResizeContain } from "./ScrollViewResizeContain.js";

export class ScrollViewResize {
    public static Center = new ScrollViewResizeCenter();
    public static Contain = new ScrollViewResizeContain();
    public static ContainMaxOriginal = new ScrollViewResizeContain(1);
}